import React, { useEffect } from "react";
import { get, post } from "../api";
import { errText, getLang, t } from "../i18n";
import { navigate, setState, toast } from "../store";
import { Button, Empty, Spinner, cx, useAsync } from "../ui";

export function Notifications() {
  const n = useAsync(() => get("/api/notifications"));
  useEffect(() => {
    if (n.data?.unread) post("/api/notifications/read").then(() => setState({ unread: 0 }));
  }, [n.data?.unread]);
  if (n.loading && !n.data) return <Spinner />;
  const list = n.data?.notifications ?? [];
  const open = async (x: any) => {
    try {
      if (x.kind === "room_invite") {
        const r = await post("/api/rooms/join", { code: x.payload.code });
        navigate(`/room/${r.room.id}`);
      } else if (x.kind === "friend_request" || x.kind === "friend_accepted") navigate("/friends");
      else if (x.kind === "dm_message") navigate(`/messages/${x.payload.username}`);
      else if (x.kind === "topup_success" || x.kind === "coins_granted" || x.kind === "gift_received") navigate("/wallet");
    } catch (e) {
      toast(errText(e), "error");
    }
  };
  return (
    <div className="notifications">
      <h1>{t.notifications}</h1>
      {list.length ? (
        <ul className="list panel">
          {list.map((x: any) => (
            <li key={x.id} className={cx("list-row", !x.read_at && "is-unread")}>
              <span className="grow">{t.notif[x.kind]?.(x.payload) ?? x.kind}</span>
              <small className="muted">{new Date(x.created_at).toLocaleString(getLang() === "ar" ? "ar-SA" : "en")}</small>
              {["room_invite", "friend_request"].includes(x.kind) && (
                <Button kind="ghost" onClick={() => open(x)}>{x.kind === "room_invite" ? t.join : t.friends}</Button>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <Empty>{t.noNotifications}</Empty>
      )}
    </div>
  );
}
